import React from 'react';
import OpportunitiesCardFooter from './OpportunitiesCardFooter';
import OpportunitiesCardTitle from './OpportunitiesCardTitle';
import OpportunitiesCardDetail from './OpportunitiesCardDetail';
import OpportunitiesCardCurrentStatus from './OpportunitiesCardCurrentStatus';
import { UIApplication, ApplicationStatus, UserCareerPathType, WorkingMode } from 'types';
import { closedApplicationStatuses, formatCareerPathType } from 'shared-utils';
import { Button } from 'flowbite-react';
import { useSearchParams } from 'react-router-dom';

const MyOpportunitiesDriveCard = ({
	application,
	setSelectedApplication,
}: {
	application: UIApplication;
	setSelectedApplication: React.Dispatch<React.SetStateAction<UIApplication | null>>;
}) => {
	const [searchParams, setSearchParams] = useSearchParams();
	return (
		<>
			<div className="relative max-w-full rounded-[14px] border border-[#E8E8F0] bg-white shadow-[0_1px_2px_rgba(20,20,60,0.04)] md:max-w-[780px]">
				<div
					className={
						'grid md:flex justify-between gap-3 px-4 py-4 md:px-6 md:py-5 bg-white rounded-tl-[14px] rounded-tr-[14px]'
					}
				>
					<div>
						<OpportunitiesCardTitle
							companyUrl={application.position?.company.url || ''}
							companyImg={application.position?.company.logo || ''}
							companyName={application.position?.company.name || ''}
							positionTitle={formatCareerPathType(application.position?.title as UserCareerPathType) || ''}
						/>
						<OpportunitiesCardDetail
							workingMode={application.position?.workingMode || ''}
							minSalary={String(application.position?.salary?.min) || ''}
							maxSalary={String(application.position?.salary?.max) || ''}
							internshipSalary={application.position?.internshipSalary}
							internshipDuration={application.position?.internshipDuration}
							location={
								Array.isArray(application.position?.workLocations)
									? application.position?.workLocations.map(location => location.split(',')[0].trim()).join(', ')
									: application.position?.workLocations || ''
							}
							type={application.position?.positionType || ''}
						/>
					</div>
					<div className="absolute right-4 top-4 md:static">
						<OpportunitiesCardCurrentStatus currentStatus={application.status} />
					</div>
				</div>

				{[
					ApplicationStatus.OFFER_ROLLED_OUT,
					ApplicationStatus.CHANGED_OFFER_TERMS,
					ApplicationStatus.VERBALLY_PLACED,
					ApplicationStatus.PLACED,
				].includes(application.status) ? (
					<div className="flex justify-end gap-3 border-t border-[#EEEEF5] px-4 py-3 md:px-6">
						<Button
							onClick={e => {
								e.stopPropagation();
								searchParams.set('viewOffer', application._id || ''); // Set new or update existing param
								setSearchParams(searchParams);
								setSelectedApplication(application);
							}}
							color="purplePlaced"
							size={'sm'}
							className="!rounded-[12px] !bg-gradient-to-b !from-[#5B4FF0] !to-[#3027D8] !text-white !shadow-[0_4px_12px_rgba(79,70,229,0.25)] hover:!opacity-95 [&>span]:!rounded-[12px] [&>span]:!px-5 [&>span]:!py-2 [&>span]:!text-[14px] [&>span]:!font-[700]"
						>
							View Offer
						</Button>
					</div>
				) : (
					<OpportunitiesCardFooter
						footerText={`Round Location: Floor ${application.position?.company?.offlineDriveRoom?.floorName || ''
							}, Room ${application.position?.company?.offlineDriveRoom?.roomName || ''} ${application.position?.company?.offlineDriveRoom?.buildingName || ''
							}`}
						room={application.position?.company?.offlineDriveRoom?.floorName}
						floor={application.position?.company?.offlineDriveRoom?.buildingName}
					/>
				)}
			</div>
		</>
	);
};

export default MyOpportunitiesDriveCard;
